export default __webpack_public_path__ + "ui/assets/img/like-green-32.svg";